import { render, staticRenderFns } from "./SimpleTriggerAdd.vue?vue&type=template&id=24141851&scoped=true"
import script from "./SimpleTriggerAdd.vue?vue&type=script&lang=js"
export * from "./SimpleTriggerAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24141851",
  null
  
)

export default component.exports